import { FaceFrownIcon } from "@heroicons/react/24/outline";
import { useOutletContext, useLocation, Outlet } from "react-router-dom";

export default function AccessRoute() {
  const location = useLocation();

  const outletContext = useOutletContext();
  const { allowedSections } = outletContext;

  const section = location.pathname.split("/")[1];

  if (allowedSections[section]) {
    return <Outlet context={outletContext} />;
  }

  return (
    <div className="h-full flex items-center justify-center gap-x-2 text-gray-500">
      <FaceFrownIcon className="size-8" />
      <p className="text-md font-semibold">Page doesn't exist</p>
    </div>
  );
}
